import React from 'react';
import PairList from '../components/PairList/PairList';
import AppLayout from '../layouts/AppLayout';

const IndexPage: React.FC = () => {
  return (
    <AppLayout>
      <PairList />
    </AppLayout>
  );
};

export default IndexPage;
